







































import { defineComponent, PropType, computed } from '@nuxtjs/composition-api';

type RadioButtonOptions = {
  disabled: boolean | false;
  value: string;
  reviewNumber: number | null;
  hasTooltip: boolean | null;
  tooltipContent: string | null;
};

export type RadioButtonLabel = {
  type: 'default';
  label: string;
} & RadioButtonOptions;

export type RadioButtonRating = {
  type: 'rating';
  score: number;
} & RadioButtonOptions;

export type FilterRadioOptionType = {
  value: string;
  label: string;
  type: string;
};

type RadioButtonList = Array<
  RadioButtonLabel | RadioButtonRating | FilterRadioOptionType
>;

export default defineComponent({
  props: {
    list: {
      type: Array as PropType<RadioButtonList>,
      default: () => [
        {
          type: 'default',
          label: 'Visa Debit',
          value: 'debit',
          hasTooltip: true,
          tooltipContent: `Exercitation consectetur enim qui esse
             amet esse eu dolore enim irure velit pariatur dolor eiusmod.`
        }
      ]
    },
    selected: {
      type: String,
      default: ''
    }
  },
  setup(props, context) {
    const selectedOption = computed(() => props.selected);
    return {
      selectedOption,
      update: (e: string) => {
        context.emit('input', e);
      }
    };
  }
});
